// Mock data para Aerotucán

export const companyInfo = {
  name: "Aerotucán",
  rating: 4.8,
  reviewCount: 239,
  phone: "+52 951 502 0840",
  address: "5 de Mayo 1022A, Jalatlaco, Oaxaca",
  email: "ventasaerotucan@gmail.com",
  hours: "Lunes a Domingo: 9:00 AM - 5:00 PM",
  yearsFlying: 25,
  foundedYear: 2001,
  coordinates: {
    lat: 17.070833,
    lng: -96.716667
  }
};

export const routes = [
{
  id: 1,
  origin: "Oaxaca de Juárez",
  originCode: "OAX",
  destination: "Puerto Escondido",
  destinationCode: "PXM",
  duration: "45 min",
  frequency: "Lunes a Sábado: 7:00 AM | Domingos: 9:00 AM",
  price: 3666.00 ,
  description: "Conecta la capital con las hermosas playas de la costa oaxaqueña",
  schedules: {
    weekdays: ["07:00"],
    sunday: ["09:00"]
  }
},
{
  id: 2,
  origin: "Oaxaca de Juárez",
  originCode: "OAX",
  destination: "Huatulco",
  destinationCode: "HUX",
  duration: "50 min",
  frequency: "Lunes a Sábado: 9:00 AM | Domingos: 11:00 AM",
  price: 3608.00,
  description: "Viaja a las bahías más espectaculares del Pacífico mexicano",
  schedules: {
    weekdays: ["09:00"],
    sunday: ["11:00"]
  }
},
// RUTA TEHUACÁN DESACTIVADA TEMPORALMENTE
// {
//   id: 3,
//   origin: "Oaxaca de Juárez",
//   destination: "Tehuacán",
//   duration: "40 min",
//   frequency: "3 días/semana",
//   price: 1650,
//   description: "Conexión rápida para negocios y turismo en Puebla"
// },
{
  id: 3,
  origin: "Puerto Escondido",
  originCode: "PXM",
  destination: "Oaxaca de Juárez",
  destinationCode: "OAX",
  duration: "45 min",
  frequency: "Lunes a Sábado: 8:00 AM | Domingos: 10:00 AM",
  price: 3370.00,
  description: "Regresa cómodamente de tus vacaciones en la costa",
  schedules: {
    weekdays: ["08:00"],
    sunday: ["10:00"]
  }
},
{
  id: 4,
  origin: "Huatulco",
  originCode: "HUX",
  destination: "Oaxaca de Juárez",
  destinationCode: "OAX",
  duration: "50 min",
  frequency: "Lunes a Sábado: 10:00 AM | Domingos: 12:00 PM",
  price: 3642,
  description: "Regresa de las bahías de Huatulco a la capital oaxaqueña",
  schedules: {
    weekdays: ["10:00"],
    sunday: ["12:00"]
  }
}];


export const testimonials = [
{
  id: 1,
  name: "María González",
  location: "Oaxaca",
  rating: 5,
  comment: "Excelente servicio, puntual y la atención del personal es muy amable. He volado con ellos más de 10 veces y siempre una experiencia increíble.",
  date: "Hace 2 semanas"
},
{
  id: 2,
  name: "Carlos Mendoza",
  location: "Puerto Escondido",
  rating: 5,
  comment: "La mejor opción para viajar entre Oaxaca y la costa. Vuelos rápidos, seguros y con excelente atención personalizada.",
  date: "Hace 1 mes"
},
{
  id: 3,
  name: "Ana Patricia Ruiz",
  location: "Ciudad de México",
  rating: 5,
  comment: "Perfecta conectividad regional. El equipo es muy profesional y te hacen sentir seguro durante todo el vuelo. Totalmente recomendable.",
  date: "Hace 3 semanas"
}];


export const benefits = [
{
  id: 1,
  title: "Calificación 4.8/5",
  description: "Basada en 239 reseñas de clientes satisfechos",
  icon: "star"
},
{
  id: 2,
  title: "Conectividad Regional",
  description: "Oaxaca - Costa - Interior con vuelos diarios",
  icon: "plane"
},
{
  id: 3,
  title: "Atención Personalizada",
  description: "Servicio cercano y flexible para cada pasajero",
  icon: "users"
},
{
  id: 4,
  title: "Base en Oaxaca",
  description: "Operación local desde Oaxaca de Juárez",
  icon: "map-pin"
}];


export const faqs = [
{
  id: 1,
  question: "¿Cuál es la política de equipaje?",
  answer: "Cada boleto incluye: 1 maleta de mano de hasta 5 kg (dimensiones máx. 55x40x20 cm) y 1 maleta documentada de hasta 15 kg. Equipaje adicional tiene un cargo de $34 MXN por cada kilogramo extra."
},
{
  id: 2,
  question: "¿Puedo cambiar o cancelar mi vuelo?",
  answer: "NO ofrecemos cancelaciones. Los cambios en tu boleto solo pueden realizarse con 48 horas de anticipación, con un costo de $600 MXN más la diferencia de tarifa si existe."
},
{
  id: 3,
  question: "¿Con cuánto tiempo de anticipación debo llegar al aeropuerto?",
  answer: "Debes llegar 1 hora antes de la salida programada. El check-in cierra 15 minutos antes del vuelo."
},
{
  id: 4,
  question: "¿Ofrecen servicio de alimentos a bordo?",
  answer: "NO ofrecemos snacks a bordo. Te recomendamos comer antes de tu vuelo."
},
{
  id: 5,
  question: "¿Cómo puedo contactar a servicio al cliente?",
  answer: "Puedes llamarnos al +52 951 502 0840 de lunes a domingo de 9:00 AM a 5:00 PM, visitarnos en nuestra oficina en 5 de Mayo 1022A, Jalatlaco, Oaxaca, o enviarnos un mensaje a través del formulario de contacto."
},
{
  id: 6,
  question: "¿La cabina está presurizada?",
  answer: "NO, nuestra cabina no está presurizada. Volamos a altitudes seguras y cómodas para vuelos regionales cortos."
},
{
  id: 6,
  question: "¿Los vuelos operan todos los días?",
  answer: "La frecuencia varía según la ruta. Nuestras rutas principales como Oaxaca-Puerto Escondido operan diariamente, mientras que otras rutas tienen frecuencia de 3-5 días por semana. Consulta el buscador de vuelos para disponibilidad específica."
}];


export const mockFlightResults = [
{
  id: "FL001",
  flightNumber: "AT-101",
  origin: "Oaxaca de Juárez",
  destination: "Puerto Escondido",
  departureTime: "07:00",
  arrivalTime: "07:45",
  date: "2025-01-15",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Lunes a Sábado"
},
{
  id: "FL002",
  flightNumber: "AT-102",
  origin: "Puerto Escondido",
  destination: "Oaxaca de Juárez",
  departureTime: "08:00",
  arrivalTime: "08:45",
  date: "2025-01-15",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Lunes a Sábado"
},
{
  id: "FL003",
  flightNumber: "AT-103",
  origin: "Oaxaca de Juárez",
  destination: "Huatulco",
  departureTime: "09:00",
  arrivalTime: "09:50",
  date: "2025-01-15",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Lunes a Sábado"
},
{
  id: "FL004",
  flightNumber: "AT-104",
  origin: "Huatulco",
  destination: "Oaxaca de Juárez",
  departureTime: "10:00",
  arrivalTime: "10:50",
  date: "2025-01-15",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Lunes a Sábado"
},
// Vuelos de Domingo
{
  id: "FL005",
  flightNumber: "AT-101D",
  origin: "Oaxaca de Juárez",
  destination: "Puerto Escondido",
  departureTime: "09:00",
  arrivalTime: "09:45",
  date: "2025-01-19",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Domingos"
},
{
  id: "FL006",
  flightNumber: "AT-102D",
  origin: "Puerto Escondido",
  destination: "Oaxaca de Juárez",
  departureTime: "10:00",
  arrivalTime: "10:45",
  date: "2025-01-19",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Domingos"
},
{
  id: "FL007",
  flightNumber: "AT-103D",
  origin: "Oaxaca de Juárez",
  destination: "Huatulco",
  departureTime: "11:00",
  arrivalTime: "11:50",
  date: "2025-01-19",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Domingos"
},
{
  id: "FL008",
  flightNumber: "AT-104D",
  origin: "Huatulco",
  destination: "Oaxaca de Juárez",
  departureTime: "12:00",
  arrivalTime: "12:50",
  date: "2025-01-19",
  price: 3666,
  availableSeats: 13,
  aircraft: "Cessna 208 Grand Caravan",
  daysOfWeek: "Domingos"
}];


// Estados de México para vuelos privados
export const mexicoStates = [
{ id: 1, name: "Aguascalientes", capital: "Aguascalientes", estimatedHours: 3.5 },
{ id: 2, name: "Baja California", capital: "Mexicali", estimatedHours: 5.5 },
{ id: 3, name: "Baja California Sur", capital: "La Paz", estimatedHours: 4.5 },
{ id: 4, name: "Campeche", capital: "San Francisco de Campeche", estimatedHours: 2.0 },
{ id: 5, name: "Chiapas", capital: "Tuxtla Gutiérrez", estimatedHours: 1.5 },
{ id: 6, name: "Chihuahua", capital: "Chihuahua", estimatedHours: 4.5 },
{ id: 7, name: "Ciudad de México", capital: "Ciudad de México", estimatedHours: 1.0 },
{ id: 8, name: "Coahuila", capital: "Saltillo", estimatedHours: 4.0 },
{ id: 9, name: "Colima", capital: "Colima", estimatedHours: 2.5 },
{ id: 10, name: "Durango", capital: "Durango", estimatedHours: 3.5 },
{ id: 11, name: "Guanajuato", capital: "Guanajuato", estimatedHours: 2.5 },
{ id: 12, name: "Guerrero", capital: "Chilpancingo", estimatedHours: 1.5 },
{ id: 13, name: "Hidalgo", capital: "Pachuca", estimatedHours: 2.0 },
{ id: 14, name: "Jalisco", capital: "Guadalajara", estimatedHours: 2.5 },
{ id: 15, name: "México", capital: "Toluca", estimatedHours: 1.5 },
{ id: 16, name: "Michoacán", capital: "Morelia", estimatedHours: 2.0 },
{ id: 17, name: "Morelos", capital: "Cuernavaca", estimatedHours: 1.5 },
{ id: 18, name: "Nayarit", capital: "Tepic", estimatedHours: 3.0 },
{ id: 19, name: "Nuevo León", capital: "Monterrey", estimatedHours: 4.0 },
{ id: 20, name: "Puebla", capital: "Puebla", estimatedHours: 1.5 },
{ id: 21, name: "Querétaro", capital: "Querétaro", estimatedHours: 2.0 },
{ id: 22, name: "Quintana Roo", capital: "Chetumal", estimatedHours: 2.5 },
{ id: 23, name: "San Luis Potosí", capital: "San Luis Potosí", estimatedHours: 3.0 },
{ id: 24, name: "Sinaloa", capital: "Culiacán", estimatedHours: 4.0 },
{ id: 25, name: "Sonora", capital: "Hermosillo", estimatedHours: 5.0 },
{ id: 26, name: "Tabasco", capital: "Villahermosa", estimatedHours: 1.5 },
{ id: 27, name: "Tamaulipas", capital: "Ciudad Victoria", estimatedHours: 4.5 },
{ id: 28, name: "Tlaxcala", capital: "Tlaxcala", estimatedHours: 2.0 },
{ id: 29, name: "Veracruz", capital: "Xalapa", estimatedHours: 1.5 },
{ id: 30, name: "Yucatán", capital: "Mérida", estimatedHours: 2.0 },
{ id: 31, name: "Zacatecas", capital: "Zacatecas", estimatedHours: 3.0 }];


export const privateFlightFeatures = [
{
  title: "Flexibilidad Total",
  description: "Elige tu horario y destino. Volamos cuando tú lo necesites."
},
{
  title: "Privacidad y Comodidad",
  description: "Viaja con tu grupo en un ambiente privado y exclusivo."
},
{
  title: "Ahorra Tiempo",
  description: "Sin escalas ni esperas. Vuelo directo a tu destino."
},
{
  title: "Cessna 208 Grand Caravan",
  description: "Aeronave confiable con capacidad para 13 pasajeros y equipaje amplio."
}];
